import React from 'react'
import { Box, MenuItem } from '@mui/material'
import Select, { Icon, SelectProps } from '@/components/common/Select'

import { SUPPORTED_CHAIN } from '@/constants'

interface NetworkOption {
  value: number
  label: string
  logoSrc: string
}

export const OPTIONS: NetworkOption[] = Object.values(SUPPORTED_CHAIN).map((chain) => ({
  value: chain.id,
  label: chain.name,
  logoSrc: chain.logoSrc,
}))

interface NetworkSelectProps extends SelectProps<number> {
  tag: string
  options?: NetworkOption[]
}

const NetworkSelect = ({ tag, value, onChange, options = OPTIONS, ...restProps }: NetworkSelectProps) => {
  return (
    <Select
      {...restProps}
      value={value}
      tag={tag}
      renderIcon={(value) => (
        <Icon
          src={
            options.find((option) => {
              return option.value === value
            })?.logoSrc
          }
          alt={
            options.find((option) => {
              return option.value === value
            })?.label
          }
        />
      )}
      renderLabel={(value) => {
        return options.find((option) => {
          return option.value === value
        })?.label
      }}
      onChange={onChange}
    >
      {options.map((option) => (
        <MenuItem key={option.value} sx={{ width: '100%', height: 60 }} value={option.value}>
          <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 8 }}>
            <Icon src={option.logoSrc} alt={option.label} />
            {option.label}
          </Box>
        </MenuItem>
      ))}
    </Select>
  )
}

export default NetworkSelect
